<template>
	<v-container>
		<v-icon
			size="50"
			color="white"
		>
			fas fa-user-shield
		</v-icon>
		<v-form
			ref="form"
			v-model="valid"
		>
			<v-layout 
				row 
				wrap
			>
				<v-flex 
					xs12
				>
					<v-text-field
						v-model="credentials.email"
						color="warning"
						label="Email"
						:rules="emailRules"
						required
					/>
				</v-flex>
				<v-flex 
					xs12
				>
					<v-text-field
						v-model="credentials.password"
						color="warning"
						label="Password"
						:rules="passwordRules"
						type="password"
						required
					>
						<!-- <template v-slot:progress>
							<v-progress-linear
								:value="credentials.password"
								:color="color"
								height="1"
							/>
						</template> -->
					</v-text-field>
				</v-flex>
				<v-flex 
					xs12
				>
					<v-text-field
						v-model="passwordConfirmation"
						:rules="passwordConfirmationRules"
						color="warning"
						label="Password confirm"
						type="password"
						required
					/>
				</v-flex>
			</v-layout>
		</v-form>
	</v-container>
</template>


<script>

export default {
	props: ['credentials'],

	data () {
		return {
			alertLabel: '',
			valid: false,
			passwordConfirmation: '',
			emailRules: [
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
			],
			passwordRules: [
				v => v.length >= 8 || 'At least 8 characters are required'
			],
			passwordConfirmationRules: [
				v => v == this.credentials.password || 'Password is different'
			]
		}
	},

	computed: {
		progress () {
			return Math.min (100, this.credentials.password.length * 10)
		},
		color () {
			return ['error', 'warning', 'success'][Math.floor (this.progress / 40)]
		}
	},

	watch: {
	
	},

	methods: {

	},

}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';

.title {
	color: $primary !important;
	text-transform: uppercase;
	font-size: 22px !important;
	font-weight: 400;
	margin: 10%;
}

.login-field {
	border-radius: 100px;
}

.sign-button {
	color: $primary;
	margin-left: 1%;
	font-size: 16px;
	text-transform: uppercase;
}

.sign-button:hover {
	text-decoration: underline;
}

.sign-disclaimer {
	font-size: 16px;
	color: rgba(0, 0, 0, 0.8);

}

.sign-in-container {
	margin-top: 5% !important;
}

</style>
